<template></template>

<script lang="ts">
import { slugify } from "@/utils";

export default {
    props: {
        titleName: {
            type: String,
            default: "title",
        },
        slugName: {
            type: String,
            default: "slug",
        },
    },
    mounted() {
        const titleInput = document.querySelector<HTMLInputElement>(
            `input[name="${this.titleName}"]`,
        );
        const slugInput = document.querySelector<HTMLInputElement>(
            `input[name="${this.slugName}"]`,
        );
        if (!titleInput || !slugInput) {
            return;
        }

        // Editing the title always regenerates the slug, even after a manual slug edit.
        titleInput.addEventListener("input", () => {
            slugInput.value = slugify(titleInput.value);
        });
    },
};
</script>
